function createDelayTimer() {
  var delayBetweenCalls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var previousCalltimestamp = 0;
  return function getDelay() {
    var delaySincePreviousCall = Math.max(delayBetweenCalls - (new Date().getTime() - previousCalltimestamp), 0);
    previousCalltimestamp = new Date().getTime() + delaySincePreviousCall;
    return delaySincePreviousCall;
  };
}
export { createDelayTimer };